import { SxProps } from '@mui/material';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';

type StyleOptions = {
  insignificantClassname: string;
};

export const significanceSx = (options: StyleOptions): SxProps => ({
  [`.${options.insignificantClassname}`]: {
    backgroundColor: unifiedPlatformColorPalette.lightGrey50,
    color: unifiedPlatformColorPalette.lightTextPrimary,
  },
});
